var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 119,
    viewBox: "0 0 154 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.485 25.5391L104.922 29.126V41.1279L143.132 38.3055C145.64 38.1222 147.704 36.7555 148.856 34.5195L153.485 25.5391Z",
    fill: "url(#paint0_linear_308_6940)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.922 40.0149L143.734 37.1453C146.243 36.962 148.306 35.5953 149.458 33.3594L148.856 34.5219C147.704 36.7578 145.64 38.1245 143.132 38.3078L104.922 41.1302V40.0096V40.0149Z",
    fill: "url(#paint1_linear_308_6940)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.132 38.3086L104.922 41.131V53.1329L132.785 51.075C135.293 50.8917 137.356 49.525 138.508 47.2891L143.137 38.3086H143.132Z",
    fill: "url(#paint2_linear_308_6940)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.925 52.016L133.385 49.9109C135.893 49.7277 137.957 48.361 139.109 46.125L138.506 47.2875C137.354 49.5234 135.291 50.8902 132.783 51.0734L104.92 53.1313V52.0107L104.925 52.016Z",
    fill: "url(#paint3_linear_308_6940)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.783 51.0742L104.92 53.1321V65.134L122.431 63.8406C124.939 63.6574 127.002 62.2907 128.154 60.0547L132.783 51.0742Z",
    fill: "url(#paint4_linear_308_6940)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.925 64.0132L123.033 62.6727C125.541 62.4894 127.604 61.1227 128.756 58.8867L128.154 60.0492C127.002 62.2852 124.939 63.6519 122.431 63.8351L104.92 65.1285V64.0079L104.925 64.0132Z",
    fill: "url(#paint5_linear_308_6940)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.462891 25.5391L49.0256 29.126V41.1279L10.8153 38.3055C8.30707 38.1222 6.24391 36.7555 5.0919 34.5195L0.462891 25.5391Z",
    fill: "url(#paint6_linear_308_6940)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.028 40.0149L10.2156 37.1453C7.70736 36.962 5.6442 35.5953 4.49219 33.3594L5.09438 34.5219C6.24639 36.7578 8.30955 38.1245 10.8178 38.3078L49.028 41.1302V40.0096V40.0149Z",
    fill: "url(#paint7_linear_308_6940)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8177 38.3086L49.028 41.131V53.1329L21.1649 51.075C18.6567 50.8917 16.5935 49.525 15.4415 47.2891L10.8125 38.3086H10.8177Z",
    fill: "url(#paint8_linear_308_6940)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0272 52.016L20.5672 49.9109C18.0589 49.7277 15.9958 48.361 14.8438 46.125L15.4459 47.2875C16.598 49.5234 18.6611 50.8902 21.1694 51.0734L49.0324 53.1313V52.0107L49.0272 52.016Z",
    fill: "url(#paint9_linear_308_6940)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1641 51.0742L49.0271 53.1321V65.134L31.5165 63.8406C29.0082 63.6574 26.9451 62.2907 25.7931 60.0547L21.1641 51.0742Z",
    fill: "url(#paint10_linear_308_6940)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0263 64.0132L30.9187 62.6727C28.4105 62.4894 26.3473 61.1227 25.1953 58.8867L25.7975 60.0492C26.9495 62.2852 29.0127 63.6519 31.5209 63.8351L49.0316 65.1285V64.0079L49.0263 64.0132Z",
    fill: "url(#paint11_linear_308_6940)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6227 95.5483C68.6528 92.8097 60.5206 89.5003 54.3574 83.5621C44.9004 74.4508 42.6016 61.1502 42.6016 48.5671V21.8037L43.2928 21.5366C53.9699 17.4051 65.4743 14.5198 76.8531 13.2683L76.9735 13.2578L77.0939 13.2683C88.4727 14.525 99.9771 17.4051 110.654 21.5366L111.345 21.8037V48.5671C111.345 61.1555 109.047 74.4508 99.5897 83.5621C93.4264 89.5003 85.2994 92.8097 77.3243 95.5483L76.9735 95.6688L76.6227 95.5483Z",
    fill: "url(#paint12_linear_308_6940)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1139 18.7832C50.3148 13.6567 63.8981 10.1064 76.9735 8.73446V3.13672C61.5155 4.6867 45.6334 9.20574 32.5371 15.1386L38.1087 18.7884L38.1139 18.7832Z",
    fill: "url(#paint13_linear_308_6940)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9728 8.73438C63.8975 10.1063 50.3089 13.6566 38.1133 18.7831L43.6848 22.5428C54.2886 18.4375 65.8245 15.5627 76.9728 14.3374V8.73438Z",
    fill: "url(#paint14_linear_308_6940)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1126 48.5674V18.7826L32.541 15.1328V48.5674C32.541 90.7993 57.2936 99.7431 76.9774 106.289V100.413C67.6984 97.2872 58.4299 93.7212 51.2456 86.7986C40.8512 76.7813 38.1178 62.4859 38.1178 48.5674H38.1126Z",
    fill: "url(#paint15_linear_308_6940)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1146 18.7812V48.5661C38.1146 62.4845 40.848 76.78 51.2423 86.7973C58.4215 93.7198 67.6952 97.2859 76.9742 100.412V94.5262C69.1195 91.8242 61.1235 88.5777 55.1068 82.7862C45.8907 73.9052 43.6809 60.856 43.6809 48.5661V22.541L38.1094 18.7812H38.1146Z",
    fill: "url(#paint16_linear_308_6940)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.838 18.7832C103.637 13.6567 90.0539 10.1064 76.9785 8.73446V3.13672C92.4365 4.6867 108.319 9.20574 121.415 15.1386L115.843 18.7884L115.838 18.7832Z",
    fill: "url(#paint17_linear_308_6940)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9727 8.73438C90.048 10.1063 103.637 13.6566 115.832 18.7831L110.261 22.5428C99.6569 18.4375 88.1158 15.5627 76.9727 14.3374V8.73438Z",
    fill: "url(#paint18_linear_308_6940)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.837 48.5674V18.7826L121.409 15.1328V48.5674C121.409 90.7993 96.6564 99.7431 76.9727 106.289V100.413C86.2516 97.2872 95.5201 93.7212 102.704 86.7986C113.099 76.7813 115.832 62.4859 115.832 48.5674H115.837Z",
    fill: "url(#paint19_linear_308_6940)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.838 18.7812V48.5661C115.838 62.4845 113.105 76.78 102.71 86.7973C95.526 93.7198 86.2575 97.2859 76.9785 100.412V94.5262C84.8332 91.8242 92.8292 88.5777 98.8459 82.7862C108.062 73.9052 110.272 60.856 110.272 48.5661V22.541L115.843 18.7812H115.838Z",
    fill: "url(#paint20_linear_308_6940)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6836 22.5414C54.146 18.6926 68.4676 16.6819 76.9716 16.3467C85.4756 16.6819 99.7972 18.6874 110.26 22.5414C99.6558 18.4361 88.1147 15.5613 76.9716 14.3359C65.8232 15.5613 54.2874 18.4361 43.6836 22.5414Z",
    fill: "url(#paint21_radial_308_6940)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.0628 78.5985C85.1967 91.2392 68.7438 91.2392 54.8777 78.5985C48.0442 72.3724 45.0385 64.0255 43.9336 55.3906C44.7295 65.5126 47.5834 75.5352 55.1029 82.7824C61.1143 88.5739 69.1104 91.8257 76.9703 94.5225C84.8249 91.8205 92.8209 88.5739 98.8376 82.7824C106.362 75.5352 109.211 65.5074 110.007 55.3906C108.902 64.0203 105.896 72.3671 99.0628 78.5933V78.5985Z",
    fill: "url(#paint22_radial_308_6940)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1332 59.2168C63.0368 59.2168 51.1448 53.64 47.4322 46.0158C45.7408 42.544 45.7042 24.981 48.0449 23.6143C53.3389 20.5248 69.2995 17.8438 77.1332 17.8438C84.9669 17.8438 100.928 20.5248 106.222 23.6143C108.562 24.981 108.526 42.5492 106.834 46.0158C103.122 53.64 91.2297 59.2168 77.1332 59.2168Z",
    fill: "url(#paint23_radial_308_6940)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9745 48.7175C65.8785 48.7175 56.5157 45.0101 53.5938 39.936C52.2637 37.6267 52.2323 24.3157 54.0755 23.4098C58.2437 21.3519 70.0938 19.1055 76.9745 19.1055C83.8551 19.1055 95.7052 21.3519 99.8734 23.4098C101.717 24.321 101.685 37.632 100.355 39.936C97.4332 45.0049 88.0705 48.7175 76.9745 48.7175Z",
    fill: "url(#paint24_radial_308_6940)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2999 46.823C37.2999 55.3846 37.8288 58.6992 40.049 66.4963C38.6195 60.6996 38.1063 54.5991 38.1063 48.5667V18.7819C49.7103 13.9068 62.5709 10.456 75.0494 8.95312C67.6136 9.79095 61.0681 10.8854 54.6116 12.5191C54.266 12.095 53.6899 11.8908 53.1349 12.0531C52.6008 12.2102 52.229 12.6553 52.1452 13.1685C50.7261 13.5612 49.3018 13.9801 47.8723 14.4304C47.3382 13.8701 46.5108 13.6345 45.7306 13.9016C44.9608 14.1634 44.4476 14.8389 44.3534 15.5929C42.2483 16.3208 40.1066 17.122 37.9073 17.9964L33.3359 15.6558L37.2999 18.9599V46.823Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M48.6605 25.5789C55.4683 25.5789 60.9871 20.0601 60.9871 13.2523C60.9871 6.44457 55.4683 0.925781 48.6605 0.925781C41.8528 0.925781 36.334 6.44457 36.334 13.2523C36.334 20.0601 41.8528 25.5789 48.6605 25.5789Z",
    fill: "url(#paint25_radial_308_6940)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4492 102.747L42.7196 109.094V102.747H21.4492Z",
    fill: "#CD74D7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.488 102.747L111.223 109.094V102.747H132.488Z",
    fill: "#CD74D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7205 109.095L26.3828 114.934V104.225L42.7205 109.095Z",
    fill: "#E195E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.223 109.095L127.555 114.934V104.225L111.223 109.095Z",
    fill: "#E195E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5516 112.01V118.645L26.3828 114.932L34.5516 112.01Z",
    fill: "#D17FDA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.389 112.01V118.645L127.552 114.932L119.389 112.01Z",
    fill: "#D17FDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_308_6940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0918 76.8035H137.231L132.676 102.75H21.6423L17.0918 76.8035Z",
    fill: "#5F488A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_6940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4141 92.1423C48.1821 92.1423 47.8981 92.1183 47.5621 92.0703C47.6021 91.6543 47.6341 91.1023 47.6581 90.4143C47.6821 89.7183 47.6941 89.0703 47.6941 88.4703C47.6941 87.9583 47.6781 87.4383 47.6461 86.9103C46.6621 86.9183 46.0501 86.9703 45.8101 87.0663C45.7701 86.7863 45.7501 86.5503 45.7501 86.3583C45.7501 86.1983 45.7701 85.9983 45.8101 85.7583C46.1381 85.7903 46.5781 85.8183 47.1301 85.8423C47.6901 85.8583 48.2181 85.8663 48.7141 85.8663C49.9061 85.8663 50.6421 85.8143 50.9221 85.7103C50.9621 85.9663 50.9821 86.1783 50.9821 86.3463C50.9821 86.5543 50.9621 86.7783 50.9221 87.0183C50.4581 86.9783 49.8501 86.9463 49.0981 86.9223C49.0581 87.7463 49.0381 88.5543 49.0381 89.3463C49.0381 90.8103 49.1021 91.7183 49.2301 92.0703C49.0141 92.1183 48.7421 92.1423 48.4141 92.1423ZM51.7762 92.1063C51.8642 90.9143 51.9082 89.7023 51.9082 88.4703C51.9082 87.7343 51.8922 87.1703 51.8602 86.7783C51.8362 86.3783 51.7882 86.0343 51.7162 85.7463C52.1562 85.8023 52.8362 85.8303 53.7562 85.8303C54.8522 85.8303 55.7042 85.8023 56.3122 85.7463C56.3122 86.0103 56.2882 86.2943 56.2402 86.5983C56.1922 86.8943 56.1322 87.0943 56.0602 87.1983C55.8602 87.0943 55.6002 87.0143 55.2802 86.9583C54.9602 86.9023 54.6322 86.8743 54.2962 86.8743C53.9362 86.8743 53.6082 86.8983 53.3122 86.9463C53.2802 87.5703 53.2642 88.0743 53.2642 88.4583C53.6002 88.4743 53.8602 88.4823 54.0442 88.4823C54.4442 88.4823 54.7522 88.4743 54.9682 88.4583C55.1842 88.4343 55.4242 88.3983 55.6882 88.3503C55.7202 88.5583 55.7362 88.7343 55.7362 88.8783C55.7362 88.9983 55.7202 89.1783 55.6882 89.4183C54.6322 89.3543 53.8202 89.3263 53.2522 89.3343C53.2522 89.9663 53.2642 90.4823 53.2882 90.8823C53.6242 90.9463 53.9802 90.9783 54.3562 90.9783C54.7242 90.9783 55.0922 90.9503 55.4602 90.8943C55.8282 90.8383 56.1282 90.7583 56.3602 90.6543C56.3602 90.9183 56.3362 91.1983 56.2882 91.4943C56.2402 91.7903 56.1802 91.9943 56.1082 92.1063C55.5722 92.0503 54.8082 92.0223 53.8162 92.0223C52.9042 92.0223 52.2242 92.0503 51.7762 92.1063ZM62.2481 92.1303C62.0001 92.1303 61.7321 92.1023 61.4441 92.0463C61.1961 91.3343 61.0201 90.8383 60.9161 90.5583C60.4921 90.5343 60.0281 90.5223 59.5241 90.5223C58.9801 90.5223 58.5961 90.5383 58.3721 90.5703C58.2361 90.9303 58.0601 91.4223 57.8441 92.0463C57.6681 92.0943 57.5081 92.1183 57.3641 92.1183C57.1801 92.1183 56.9921 92.0943 56.8001 92.0463C57.0241 91.6463 57.4201 90.7023 57.9881 89.2143C58.5561 87.7263 58.9801 86.5623 59.2601 85.7223C59.5401 85.6823 59.7761 85.6623 59.9681 85.6623C60.1681 85.6623 60.3881 85.6823 60.6281 85.7223C60.9081 86.5623 61.3321 87.7263 61.9001 89.2143C62.4681 90.7023 62.8641 91.6463 63.0881 92.0463C62.8321 92.1023 62.5521 92.1303 62.2481 92.1303ZM59.9801 89.6943C60.1481 89.6943 60.3521 89.6863 60.5921 89.6703C60.2161 88.6303 59.9001 87.8143 59.6441 87.2223C59.3881 87.8463 59.0761 88.6583 58.7081 89.6583C59.1001 89.6823 59.5241 89.6943 59.9801 89.6943ZM64.3508 92.1423C64.2068 92.1423 64.0308 92.1183 63.8228 92.0703C63.8868 91.2383 63.9188 90.0583 63.9188 88.5303C63.9188 87.2423 63.8708 86.3143 63.7748 85.7463C64.0148 85.6983 64.2668 85.6743 64.5308 85.6743C64.7948 85.6743 65.0788 85.6983 65.3828 85.7463C65.5988 86.2583 65.9068 86.9583 66.3068 87.8463C66.7148 88.7343 67.0668 89.4783 67.3628 90.0783C67.6668 89.4543 68.0108 88.7223 68.3948 87.8823C68.7788 87.0343 69.0948 86.3223 69.3428 85.7463C69.5428 85.6983 69.8028 85.6743 70.1228 85.6743C70.3788 85.6743 70.6748 85.6983 71.0108 85.7463C70.9708 86.1463 70.9388 86.6943 70.9148 87.3903C70.8908 88.0783 70.8788 88.7303 70.8788 89.3463C70.8788 90.8103 70.9428 91.7183 71.0708 92.0703C70.7988 92.1183 70.5148 92.1423 70.2188 92.1423C69.9868 92.1423 69.7148 92.1183 69.4028 92.0703C69.4428 91.6703 69.4748 91.1263 69.4988 90.4383C69.5228 89.7423 69.5348 89.0863 69.5348 88.4703C69.5348 88.1743 69.5268 87.8183 69.5108 87.4023C69.1588 88.1223 68.7708 88.9463 68.3468 89.8743C67.9308 90.7943 67.6068 91.5263 67.3748 92.0703C67.2548 92.1103 67.1468 92.1303 67.0508 92.1303C66.9708 92.1303 66.8708 92.1103 66.7508 92.0703C66.5508 91.6063 66.2628 90.9583 65.8868 90.1263C65.5108 89.2943 65.1508 88.5223 64.8068 87.8103C64.7988 88.1463 64.7948 88.6583 64.7948 89.3463C64.7948 90.7863 64.8388 91.6943 64.9268 92.0703C64.7348 92.1183 64.5428 92.1423 64.3508 92.1423ZM76.0897 92.1423C75.8337 92.1423 75.5417 92.1183 75.2137 92.0703C75.2537 91.6783 75.2857 91.1423 75.3097 90.4623C75.3337 89.7743 75.3457 89.1303 75.3457 88.5303C75.3457 87.1623 75.2817 86.3223 75.1537 86.0103C75.4097 85.9143 75.7617 85.8383 76.2097 85.7823C76.6577 85.7183 77.1057 85.6863 77.5537 85.6863C78.3937 85.6863 79.0377 85.8703 79.4857 86.2383C79.9417 86.5983 80.1697 87.1183 80.1697 87.7983C80.1697 88.2543 80.0537 88.6623 79.8217 89.0223C79.5897 89.3743 79.2657 89.6503 78.8497 89.8503C78.4417 90.0503 77.9697 90.1503 77.4337 90.1503C77.2017 90.1503 76.9577 90.1303 76.7017 90.0903C76.7177 91.1143 76.7777 91.7743 76.8817 92.0703C76.6177 92.1183 76.3537 92.1423 76.0897 92.1423ZM77.8777 89.3823C78.1177 89.2543 78.3137 89.0583 78.4657 88.7943C78.6257 88.5223 78.7057 88.2223 78.7057 87.8943C78.7057 87.0463 78.2377 86.6223 77.3017 86.6223C77.0937 86.6223 76.9137 86.6423 76.7617 86.6823C76.7137 87.6263 76.6897 88.4463 76.6897 89.1423C77.2097 89.3023 77.6057 89.3823 77.8777 89.3823ZM81.1434 92.1063C81.2314 90.9063 81.2754 89.7143 81.2754 88.5303C81.2754 87.0103 81.2114 86.0823 81.0834 85.7463C81.3474 85.6983 81.6194 85.6743 81.8994 85.6743C82.1474 85.6743 82.4314 85.6983 82.7514 85.7463C82.7114 86.1623 82.6794 86.7183 82.6554 87.4143C82.6314 88.1023 82.6194 88.7463 82.6194 89.3463C82.6194 90.0263 82.6314 90.5583 82.6554 90.9423C82.9994 91.0063 83.3674 91.0383 83.7594 91.0383C84.0474 91.0383 84.3394 91.0103 84.6354 90.9543C84.9394 90.8903 85.1954 90.8103 85.4034 90.7143C85.4034 90.9703 85.3794 91.2423 85.3314 91.5303C85.2834 91.8103 85.2234 92.0023 85.1514 92.1063C84.6954 92.0503 84.0514 92.0223 83.2194 92.0223C82.2914 92.0223 81.5994 92.0503 81.1434 92.1063ZM90.9824 92.1303C90.7344 92.1303 90.4664 92.1023 90.1784 92.0463C89.9304 91.3343 89.7544 90.8383 89.6504 90.5583C89.2264 90.5343 88.7624 90.5223 88.2584 90.5223C87.7144 90.5223 87.3304 90.5383 87.1064 90.5703C86.9704 90.9303 86.7944 91.4223 86.5784 92.0463C86.4024 92.0943 86.2424 92.1183 86.0984 92.1183C85.9144 92.1183 85.7264 92.0943 85.5344 92.0463C85.7584 91.6463 86.1544 90.7023 86.7224 89.2143C87.2904 87.7263 87.7144 86.5623 87.9944 85.7223C88.2744 85.6823 88.5104 85.6623 88.7024 85.6623C88.9024 85.6623 89.1224 85.6823 89.3624 85.7223C89.6424 86.5623 90.0664 87.7263 90.6344 89.2143C91.2024 90.7023 91.5984 91.6463 91.8224 92.0463C91.5664 92.1023 91.2864 92.1303 90.9824 92.1303ZM88.7144 89.6943C88.8824 89.6943 89.0864 89.6863 89.3264 89.6703C88.9504 88.6303 88.6344 87.8143 88.3784 87.2223C88.1224 87.8463 87.8104 88.6583 87.4424 89.6583C87.8344 89.6823 88.2584 89.6943 88.7144 89.6943ZM94.2063 92.1423C93.9503 92.1423 93.6543 92.1183 93.3183 92.0703C93.3823 91.5103 93.4223 90.7623 93.4383 89.8263C93.0703 89.0103 92.6503 88.1983 92.1783 87.3903C91.7063 86.5823 91.3863 86.0943 91.2183 85.9263C91.6903 85.7583 92.2903 85.6743 93.0183 85.6743C93.0743 85.8663 93.2343 86.2623 93.4983 86.8623C93.7623 87.4623 94.0623 88.0743 94.3983 88.6983C94.7823 87.9543 95.0703 87.3343 95.2623 86.8383C95.4543 86.3343 95.5583 85.9703 95.5743 85.7463C96.0063 85.6983 96.4783 85.6743 96.9903 85.6743C96.3503 86.5943 95.6183 87.9743 94.7943 89.8143C94.7943 91.0303 94.8583 91.7823 94.9863 92.0703C94.7383 92.1183 94.4783 92.1423 94.2063 92.1423ZM97.7488 92.1063C97.8368 90.9143 97.8808 89.7023 97.8808 88.4703C97.8808 87.7343 97.8648 87.1703 97.8328 86.7783C97.8088 86.3783 97.7608 86.0343 97.6888 85.7463C98.1288 85.8023 98.8088 85.8303 99.7288 85.8303C100.825 85.8303 101.677 85.8023 102.285 85.7463C102.285 86.0103 102.261 86.2943 102.213 86.5983C102.165 86.8943 102.105 87.0943 102.033 87.1983C101.833 87.0943 101.573 87.0143 101.253 86.9583C100.933 86.9023 100.605 86.8743 100.269 86.8743C99.9088 86.8743 99.5808 86.8983 99.2848 86.9463C99.2528 87.5703 99.2368 88.0743 99.2368 88.4583C99.5728 88.4743 99.8328 88.4823 100.017 88.4823C100.417 88.4823 100.725 88.4743 100.941 88.4583C101.157 88.4343 101.397 88.3983 101.661 88.3503C101.693 88.5583 101.709 88.7343 101.709 88.8783C101.709 88.9983 101.693 89.1783 101.661 89.4183C100.605 89.3543 99.7928 89.3263 99.2248 89.3343C99.2248 89.9663 99.2368 90.4823 99.2608 90.8823C99.5968 90.9463 99.9528 90.9783 100.329 90.9783C100.697 90.9783 101.065 90.9503 101.433 90.8943C101.801 90.8383 102.101 90.7583 102.333 90.6543C102.333 90.9183 102.309 91.1983 102.261 91.4943C102.213 91.7903 102.153 91.9943 102.081 92.1063C101.545 92.0503 100.781 92.0223 99.7888 92.0223C98.8768 92.0223 98.1968 92.0503 97.7488 92.1063ZM104.297 92.1423C104.041 92.1423 103.749 92.1183 103.421 92.0703C103.461 91.6783 103.493 91.1383 103.517 90.4503C103.541 89.7543 103.553 89.1143 103.553 88.5303C103.553 87.1623 103.489 86.3223 103.361 86.0103C103.617 85.9143 103.969 85.8383 104.417 85.7823C104.865 85.7183 105.313 85.6863 105.761 85.6863C106.601 85.6863 107.245 85.8703 107.693 86.2383C108.149 86.5983 108.377 87.1183 108.377 87.7983C108.377 88.1903 108.269 88.5423 108.053 88.8543C107.845 89.1583 107.553 89.4023 107.177 89.5863C107.801 90.8103 108.297 91.5783 108.665 91.8903C108.401 91.9863 108.129 92.0503 107.849 92.0823C107.577 92.1223 107.265 92.1423 106.913 92.1423C106.753 91.7183 106.385 90.9703 105.809 89.8983L105.617 89.9103C105.457 89.9103 105.217 89.8903 104.897 89.8503C104.905 90.9783 104.969 91.7183 105.089 92.0703C104.825 92.1183 104.561 92.1423 104.297 92.1423ZM106.085 89.1423C106.333 89.0143 106.533 88.8423 106.685 88.6263C106.837 88.4103 106.913 88.1663 106.913 87.8943C106.913 87.0463 106.445 86.6223 105.509 86.6223C105.301 86.6223 105.121 86.6423 104.969 86.6823C104.937 87.2903 104.913 88.0263 104.897 88.8903C105.425 89.0583 105.821 89.1423 106.085 89.1423Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_308_6940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.086 62.1018C87.6159 62.1018 88.1475 62.1278 88.6765 62.0974C92.4805 61.8788 95.4636 58.7336 95.4749 54.9343C95.481 53.0408 95.494 51.1463 95.4714 49.2537C95.4436 46.9255 94.4959 45.0181 92.6577 43.6007C90.4113 41.8685 87.8704 41.7566 85.2296 42.4219C84.9438 42.4939 84.81 42.441 84.6067 42.2398C83.9926 41.6326 83.3871 40.995 82.6861 40.4989C80.2025 38.7441 77.3836 38.6426 74.5222 39.0754C72.3209 39.4085 70.5357 40.5578 69.0955 42.2493C68.9982 42.3629 68.7688 42.4792 68.6498 42.441C67.3537 42.0272 66.0325 42.0064 64.6973 42.1287C61.1878 42.4505 58.289 45.5992 58.2742 49.1166C58.2655 51.1116 58.2638 53.1067 58.2786 55.1009C58.282 55.5302 58.3333 55.9683 58.4262 56.3881C59.1846 59.8083 62.0826 62.1174 65.6207 62.1373C65.9665 62.1391 66.3131 62.1373 66.6762 62.1373C66.3217 61.4382 66.0273 60.8275 65.6998 60.2351C65.6364 60.1197 65.4487 60.02 65.3097 60.0078C62.4344 59.7667 60.4234 57.6589 60.3773 54.7765C60.3487 52.9696 60.3504 51.162 60.3773 49.356C60.4138 46.8952 62.0235 44.8741 64.3941 44.3476C65.0344 44.2053 65.7154 44.2149 66.3782 44.2131C68.9174 44.2088 71.1708 46.1787 71.401 48.7028C71.5261 50.0794 71.4626 51.4742 71.4644 52.8612C71.4652 53.7711 71.4913 54.6863 71.3975 55.5884C71.2724 56.8027 70.6973 57.8176 69.7496 58.6746C69.3674 57.8835 69.1528 57.1037 69.1432 56.2944C69.1154 53.8518 69.1241 51.4092 69.1207 48.9657C69.1189 47.8051 68.3414 46.8292 67.1201 46.5204C67.0766 46.9099 66.9993 47.2924 66.9976 47.675C66.9863 50.4932 66.8864 53.3166 67.015 56.1296C67.1922 60.0078 69.1771 62.7489 72.7274 64.3275C74.6438 65.1802 76.68 65.1533 78.704 64.9365C83.1586 64.4594 86.742 60.4433 86.755 55.97C86.7628 53.281 86.7619 50.5921 86.7507 47.904C86.7489 47.4477 86.6759 46.9914 86.6351 46.5291C85.458 46.7789 84.6293 47.7895 84.6276 48.9093C84.6232 51.3233 84.6302 53.7373 84.6067 56.1513C84.598 57.0153 84.3965 57.848 83.9874 58.6746C82.8433 57.6068 82.2856 56.3447 82.2674 54.8597C82.2456 53.0243 82.2335 51.1871 82.2691 49.3525C82.3047 47.5084 83.0935 46.0425 84.651 45.0198C85.4954 44.4647 86.4362 44.273 87.4404 44.194C91.0385 43.9121 93.615 46.6002 93.3744 50.0855C93.2649 51.6685 93.3709 53.2646 93.3466 54.8545C93.3396 55.3255 93.2728 55.8096 93.1451 56.2623C92.5509 58.3797 90.7232 59.8231 88.4802 60.0009C88.3343 60.0122 88.1241 60.0798 88.065 60.1883C87.7236 60.8041 87.4195 61.4408 87.0868 62.1L87.086 62.1018ZM82.448 31.0432C82.4428 27.9509 79.9775 25.4822 76.8858 25.4727C73.762 25.4631 71.2958 27.9483 71.3011 31.0996C71.3063 34.1494 73.7864 36.6224 76.8554 36.638C79.9402 36.6536 82.4524 34.1399 82.4472 31.0432H82.448ZM65.9308 31.3641C63.528 31.3659 61.5805 33.3089 61.5978 35.6882C61.6152 38.0883 63.5437 39.981 65.9656 39.9749C68.3458 39.9689 70.2465 38.0502 70.2456 35.6544C70.2456 33.2811 68.3163 31.3633 65.9308 31.365V31.3641ZM87.8035 39.9749C90.195 39.9802 92.1226 38.0788 92.1348 35.7021C92.1469 33.295 90.2315 31.3685 87.8235 31.3641C85.4198 31.3607 83.4801 33.2915 83.487 35.6821C83.4939 38.0597 85.4137 39.9689 87.8035 39.9741V39.9749Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_308_6940",
    x: 17.0918,
    y: 76.8037,
    width: 120.139,
    height: 28.9463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_308_6940"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_6940",
    x: 41.7501,
    y: 85.6621,
    width: 70.9146,
    height: 14.4805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_6940"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_6940",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_308_6940",
    x: 54.2676,
    y: 24.4727,
    width: 45.2166,
    height: 48.5918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_6940"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_6940",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_308_6940"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_6940",
    x1: 104.922,
    y1: 33.3361,
    x2: 153.485,
    y2: 33.3361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_6940",
    x1: 104.922,
    y1: 37.2448,
    x2: 149.452,
    y2: 37.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_6940",
    x1: 0.460286,
    y1: 45.7234,
    x2: 143.132,
    y2: 45.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_6940",
    x1: 0.463578,
    y1: 49.6282,
    x2: 139.109,
    y2: 49.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_6940",
    x1: 0.463556,
    y1: 58.1067,
    x2: 132.783,
    y2: 58.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_6940",
    x1: 0.463564,
    y1: 62.0129,
    x2: 128.756,
    y2: 62.0129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_6940",
    x1: 0.462891,
    y1: 33.3361,
    x2: 49.0256,
    y2: 33.3361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_6940",
    x1: 4.49219,
    y1: 37.2448,
    x2: 49.028,
    y2: 37.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_6940",
    x1: 10.8177,
    y1: 45.7234,
    x2: 0.988953,
    y2: 45.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_6940",
    x1: 14.8438,
    y1: 49.6282,
    x2: 0.98815,
    y2: 49.6282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_308_6940",
    x1: 21.1641,
    y1: 58.1067,
    x2: 0.988089,
    y2: 58.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_308_6940",
    x1: 25.1953,
    y1: 62.0129,
    x2: 0.987286,
    y2: 62.0129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_308_6940",
    x1: 76.9735,
    y1: 95.6688,
    x2: 76.9735,
    y2: 13.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40526F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_308_6940",
    x1: 32.5423,
    y1: 10.9599,
    x2: 76.9735,
    y2: 10.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_308_6940",
    x1: 38.1133,
    y1: 15.6412,
    x2: 76.9728,
    y2: 15.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_308_6940",
    x1: 54.7592,
    y1: 106.289,
    x2: 54.7592,
    y2: 15.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_308_6940",
    x1: 57.547,
    y1: 100.412,
    x2: 57.547,
    y2: 18.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_308_6940",
    x1: 76.9733,
    y1: 10.9599,
    x2: 121.41,
    y2: 10.9599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_308_6940",
    x1: 76.9727,
    y1: 0.926855,
    x2: 115.837,
    y2: 0.926855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_308_6940",
    x1: 99.1908,
    y1: 106.289,
    x2: 99.1908,
    y2: 15.1328,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_308_6940",
    x1: 96.4057,
    y1: 100.412,
    x2: 96.4057,
    y2: 18.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_308_6940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.9716 70.5019) scale(74.682 74.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DFE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C3C9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFB7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_308_6940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.7713 54.9036) scale(42.9597 42.9597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA5B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_308_6940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3882 -5.69925) scale(65.7236 66.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927793,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_308_6940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.367 -21.3826) scale(65.4405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_308_6940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6605 13.2523) scale(12.3266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7A90AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#556476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#37404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1F252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamPlayer);
export default __webpack_public_path__ + "static/media/team-player.bf375871dd3f028b70d671192482aa55.svg";
export { ForwardRef as ReactComponent };